module.exports = __webpack_public_path__ + "img/最近咨询.png";